import Retention from "components/Retention/Retention";

export default function RetentionView() {
  return <Retention />;
}
